import { useState, useEffect, useCallback } from 'react';
import { validateCPFOrCNPJ } from '@/utils/validations';

export type ClienteType = 'PF' | 'PJ' | null;

interface UseClienteTypeDetectionProps {
  cpfCnpj?: string;
}

export const useClienteTypeDetection = ({ cpfCnpj }: UseClienteTypeDetectionProps) => {
  const [clienteType, setClienteType] = useState<ClienteType>(null);
  const [lastDetectedValue, setLastDetectedValue] = useState<string>('');

  const detectClienteType = useCallback((value: string) => {
    if (!value || value.length < 11) {
      setClienteType(null);
      return null;
    }

    const cleaned = value.replace(/\D/g, '');

    // Verifica se é um documento válido
    if (!validateCPFOrCNPJ(cleaned)) {
      setClienteType(null);
      return null;
    }

    // Detecta o tipo baseado no tamanho
    const type: ClienteType = cleaned.length === 11 ? 'PF' : 'PJ';

    // Só atualiza se o valor mudou
    if (cleaned !== lastDetectedValue) {
      setLastDetectedValue(cleaned);
      setClienteType(type);
    }

    return type;
  }, [lastDetectedValue]);

  useEffect(() => {
    if (cpfCnpj) {
      detectClienteType(cpfCnpj);
    } else {
      setClienteType(null);
      setLastDetectedValue('');
    }
  }, [cpfCnpj, detectClienteType]);

  return {
    clienteType,
    detectClienteType,
    isPF: clienteType === 'PF',
    isPJ: clienteType === 'PJ'
  };
};
